import React from 'react';
import notify from "devextreme/ui/notify";
import { PivotGrid, HeaderFilter, FieldChooser, FieldPanel } from 'devextreme-react/pivot-grid';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { criarCuboImoveisDs, criarFatorCorretivoDs } from "../../DataSources";

export default class CuboImoveis extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fatoresCorretivos: []
        };
        this.fatorToObjectArray = this.fatorToObjectArray.bind(this);

        this.fatoresCorretivos = criarFatorCorretivoDs();
        this.fatorOptions = [];

    }

    componentDidMount() {

        criarFatorCorretivoDs().load().then(data => {
            this.setState({ fatoresCorretivos: data });
            console.log(data);
        });

    }

    fatorToObjectArray() {
        let obj = { caption: '', dataField: '', area: 'filter' };
        let fatorOptions = [];
        for (let i = 0; i < this.state.fatoresCorretivos.length; i++) {
            obj = {};
            obj.caption = this.state.fatoresCorretivos[i].descricao;
            obj.caption = obj.caption.toLowerCase();
            obj.caption = obj.caption.charAt(0).toUpperCase() + obj.caption.substring(1);
            obj.dataField = "colFator" + this.state.fatoresCorretivos[i].id;
            obj.area = 'filter';
            this.fatorOptions.push(obj);
        }
    }

    render() {
        { this.fatorToObjectArray() };
        { console.log(this.fatorOptions) }

        const dataSource = new PivotGridDataSource({
            fields: [
                {
                    caption: 'Alíquota',
                    dataField: 'aliquotaIptu',
                    area: 'filter',
                }, {
                    caption: 'Ano da Construção',
                    dataField: 'anoConstrucao',
                    area: 'filter'
                }, {
                    caption: 'Área Edificada',
                    dataField: 'areaEdificada',
                    area: 'filter'
                }, {
                    caption: 'Área de Lote',
                    dataField: 'areaLote',
                    area: 'filter'
                }, {
                    caption: 'Área Privada',
                    dataField: 'areaPrivada',
                    area: 'filter'
                }, {
                    caption: 'Nome',
                    dataField: 'descricaoNome',
                    area: 'filter'
                }, {
                    caption: 'Cartografia',
                    dataField: 'cartografiaFormatada',
                    area: 'filter'
                }, {
                    caption: 'CEP',
                    dataField: 'cepFormatado',
                    area: 'filter'
                }, {
                    caption: 'Contribuinte',
                    dataField: 'contribuinteNome',
                    area: 'filter'
                }, {
                    dataField: 'dataDeCadastro',
                    dataType: 'date',
                    area: 'filter'
                }, {
                    dataField: 'dataDeInativacao',
                    dataType: 'date',
                    area: 'filter'
                }, {
                    caption: 'Distrito',
                    dataField: 'distritoDescricao',
                    area: 'filter'
                }, {
                    caption: 'Bairro',
                    dataField: 'bairro',
                    area: 'filter'
                }, {
                    caption: 'Id',
                    dataField: 'id',
                    area: 'filter'
                }, {
                    caption: 'Nome do Logradouro',
                    dataField: 'logradouroNome',
                    area: 'filter'
                }, {
                    caption: 'Testada 2',
                    dataField: 'logradouroTestada2Nome',
                    area: 'filter'
                }, {
                    caption: 'Testada 3',
                    dataField: 'logradouroTestada3Nome',
                    area: 'filter'
                }, {
                    caption: 'Testada 4',
                    dataField: 'logradouroTestada4Nome',
                    area: 'filter'
                }, {
                    caption: 'Loteamento',
                    dataField: 'loteamento',
                    area: 'filter'
                }, {
                    caption: 'Cartografia do Lote',
                    dataField: 'loteCartografia',
                    area: 'filter'
                }, {
                    caption: 'Motivo de Isenção do Iptu',
                    dataField: 'motivoDeIsencaoDeIptuDescricao',
                    area: 'filter'
                }, {
                    caption: 'Motivo de Isenção do Tsu',
                    dataField: 'motivoDeIsencaoDeTsuDescricao',
                    area: 'filter'
                }, {
                    caption: 'Natureza',
                    dataField: 'naturezaStr',
                    area: 'filter'
                }, {
                    caption: 'Patrimonio',
                    dataField: 'patrimonioStr',
                    area: 'filter'
                }, {
                    caption: 'Posição Fiscal do Iptu',
                    dataField: 'posicaoFiscalStr',
                    area: 'filter'
                }, {
                    caption: 'Posição Fiscal do Tsu',
                    dataField: 'posicaoFiscalTsuStr',
                    area: 'filter'
                }, {
                    caption: 'Posição Patrimonial',
                    dataField: 'posicaoPatrimonialStr',
                    area: 'filter'
                }, {
                    caption: 'Cartografia da Quadra',
                    dataField: 'quadraCartografiaCompleta',
                    area: 'filter'
                }, {
                    caption: 'Segmento',
                    dataField: 'segmentoDescricao',
                    area: 'filter'
                }, {
                    caption: 'Setor',
                    dataField: 'setorCartografia',
                    area: 'filter'
                }, {
                    caption: 'Tipo de Patrimonio',
                    dataField: 'tipoDePatrimonio',
                    area: 'filter'
                }, {
                    caption: 'Uso do Imóvel',
                    dataField: 'usoDoImovelStr',
                    area: 'filter'
                }, {
                    caption: 'Quantidade de WC',
                    dataField: 'wC',
                    area: 'filter'
                }, {
                    caption: 'Quantidade',
                    dataField: 'quantidade',
                    area: 'data'
                }, {
                    caption: 'Unidades',
                    dataField: 'unidades',
                    area: 'filter'
                }].concat(this.fatorOptions),
            store: criarCuboImoveisDs()
        });
        { console.log(this.state) }
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <div><h5>Cubo de Imóveis</h5></div>
                <PivotGrid
                    id="id"
                    allowFiltering={true}
                    allowSorting={true}
                    allowSortingBySummary={true}
                    height={'100%'}
                    showBorders={true}
                    dataSource={dataSource}
                >
                    <HeaderFilter
                        width={300}
                        height={400}

                    />
                    <FieldChooser allowSearch={true} />
                    <FieldPanel visible={true} />
                </PivotGrid>
            </div>
        );
    }

}
